import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation
} from '@angular/core';
import { CertificateComponent } from '../../sprinklers/certificate-sprinklers/certificate.component';

@Component({
  selector: 'authority-labs-certificate-integration',
  templateUrl: './certificate-integration.component.html',
  styleUrls: ['./certificate-integration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateIntegrationComponent extends CertificateComponent {}
